import React from 'react';
import { Box, Card, Typography, Stack, Divider } from '@mui/material';
import { stripHtmlTags } from '../../../controllers/AuxController';

export default function OrderDetailsDataTable({ details, total }) {
    return (
        <Card 
            elevation={0} 
            sx={{ 
                border: '1px solid #f0f0f0', 
                borderRadius: 4, 
                p: { xs: 2.5, sm: 4 }, 
                bgcolor: '#fff' 
            }}
        >
            <Typography variant="h6" fontWeight="800" color="#111" mb={2}>
                Resumen de Artículos
            </Typography>
            
            <Divider sx={{ mb: 3 }} />

            <Stack spacing={0}>
                {details.map((item, index) => (
                    <Box key={index}>
                        <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={2}>
                            {/* Lado Izquierdo: Nombre, Descripción y Multiplicador */}
                            <Box flexGrow={1}>
                                <Typography variant="subtitle1" fontWeight="700" color="#222" lineHeight={1.2}>
                                    {item.product_name}
                                </Typography>
                                
                                {item.description && (
                                    <Typography variant="body2" color="text.secondary" mt={0.5} sx={{ maxWidth: '90%' }} >
                                        {stripHtmlTags(item.description)}
                                    </Typography>
                                )}
                                
                                <Typography variant="caption" fontWeight="700" color="primary.main" display="block" mt={1}>
                                    {parseInt(item.quantity)} x ${parseFloat(item.price).toFixed(2)}
                                </Typography>
                            </Box>

                            {/* Lado Derecho: Subtotal de la línea */}
                            <Box textAlign="right">
                                <Typography variant="subtitle1" fontWeight="800" color="#111">
                                    ${parseFloat(item.total_amount).toFixed(2)}
                                </Typography>
                            </Box>
                        </Stack>
                        
                        {/* Divisor punteado para todos los elementos menos el último */}
                        {index < details.length - 1 && (
                            <Divider sx={{ my: 2.5, borderStyle: 'dashed', borderColor: '#e0e0e0' }} />
                        )}
                    </Box>
                ))}
            </Stack>

            {/* --- CAJA DEL TOTAL ESTILO TICKET --- */}
            <Box 
                sx={{ 
                    mt: 4, 
                    p: { xs: 2, sm: 3 }, 
                    bgcolor: '#f8f9fa', 
                    borderRadius: 3,
                    border: '1px solid #f0f0f0' 
                }}
            >
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="body1" fontWeight="700" color="text.secondary" textTransform="uppercase" letterSpacing={0.5}>
                        Total del Pedido
                    </Typography>
                    <Typography variant="h5" fontWeight="900" color="primary.main">
                        ${parseFloat(total).toFixed(2)}
                    </Typography>
                </Stack>
            </Box>
        </Card>
    );
}